module.exports = __webpack_public_path__ + "static/img/Virgo.96b3e4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Virgo.svg
// module id = 1405
// module chunks = 0